import {
  TaskStatusDisplayLabel,
  TaskStatusKey,
  TaskStatusParamsKey,
} from './enums';

export const getTaskStatusArray = () => [
  {
    label: TaskStatusDisplayLabel.DueToday,
    key: TaskStatusKey.DueToday,
  },
  {
    label: TaskStatusDisplayLabel.Upcoming,
    key: TaskStatusKey.Upcoming,
  },
  {
    label: TaskStatusDisplayLabel.Overdue,
    key: TaskStatusKey.Overdue,
  },
  {
    label: TaskStatusDisplayLabel.Completed,
    key: TaskStatusKey.Completed,
  },
  {
    label: TaskStatusDisplayLabel.Skipped,
    key: TaskStatusKey.Skipped,
  },
  {
    label: TaskStatusDisplayLabel.Failed,
    key: TaskStatusKey.Failed,
  },
];

export const getTaskStatusParams = (
  status: TaskStatusKey,
): TaskStatusParamsKey => {
  if (status === TaskStatusKey.Upcoming) {
    return TaskStatusParamsKey.Upcoming;
  }
  if (status === TaskStatusKey.Skipped) {
    return TaskStatusParamsKey.Skipped;
  }
  if (status === TaskStatusKey.Completed) {
    return TaskStatusParamsKey.Completed;
  }
  if (status === TaskStatusKey.Overdue) {
    return TaskStatusParamsKey.Overdue;
  }
  if (status === TaskStatusKey.Failed) {
    return TaskStatusParamsKey.Failed;
  }

  return TaskStatusParamsKey.DueToday;
};

export const getInitialTaskStatus = (locationSearch: string): TaskStatusKey => {
  const searchParams = new URLSearchParams(locationSearch);
  const statusParam: string = searchParams.get('status');

  const taskStatusKeyObject = Object.keys(TaskStatusKey).reduce((acc, key) => {
    acc[key] = TaskStatusKey[key];
    return acc;
  }, {});
  const keyExists = Object.values(taskStatusKeyObject).includes(statusParam);

  if (statusParam && keyExists) {
    return statusParam as TaskStatusKey;
  }
  return TaskStatusKey.DueToday;
};
